import styled from "styled-components";
export const HotelSearchBoxWrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--pou-border-light, #d8d8d8);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);

  .hotel-search-form {
    margin: 0;
  }

  .search-row {
    display: flex;
    align-items: stretch;
    gap: 10px;
    flex-wrap: nowrap;
    @media (max-width: 900px) {
      flex-wrap: wrap;
    }
  }

  .ant-form-item {
    margin: 0;
  }
  .ant-form-item-label {
    display: none;
  }

  .input-shell {
    flex: 1;
    min-width: 180px;
    height: 46px;
    display: flex;
    align-items: center;
    gap: 12px;
    background: #ffffff;
    border: 1px solid var(--pou-border-light, #d8d8d8);
    border-radius: 6px;
    padding: 0 12px;
    box-shadow: none;
  }

  .input-shell .ant-select {
    width: 100%;
  }

  .input-shell .ant-select-selector {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    height: 100% !important;
    display: flex;
    align-items: center;
    padding: 0 !important;
  }

  .input-shell .ant-select-selection-item,
  .input-shell .ant-select-selection-placeholder {
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    display: flex;
    align-items: center;
  }

  &.hide-selected-city .ant-select-selection-item {
    color: transparent;
  }

  .input-shell .ant-select-arrow {
    color: #111827;
  }

  .hotel-city-dropdown {
    background: #ffffff;
  }
  .hotel-city-dropdown .ant-select-item-option-content {
    color: #111827;
  }
  .hotel-city-dropdown .ant-select-item-option-selected {
    background: rgba(10, 114, 216, 0.08);
  }
  .hotel-city-dropdown .ant-select-item-option-active {
    background: rgba(10, 114, 216, 0.12);
  }

  .input-shell .ant-picker {
    border: none;
    box-shadow: none;
    padding: 0;
    width: 100%;
    height: auto;
    background: transparent;
    display: flex;
    align-items: center;
  }
  .input-shell .ant-picker-input > input {
    font-size: 13px;
    font-weight: 600;
    color: #111827;
  }
  .input-shell .ant-picker-separator,
  .input-shell .ant-picker-suffix {
    color: #111827;
  }
  .input-shell .ant-picker-focused {
    box-shadow: none !important;
  }
  .date-shell {
    gap: 14px;
  }

  .date-grid {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
  }

  .date-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
  }

  .date-label {
    font-size: 11px;
    font-weight: 700;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .date-divider {
    width: 1px;
    height: 28px;
    background: #e5e7eb;
  }

  .date-shell .ant-picker {
    width: 100%;
    padding: 0;
  }

  .date-shell .ant-picker-input > input {
    font-size: 13px;
    font-weight: 500;
    /* font-weight: 700; */
  }

  .hotel-date-popup .ant-picker-panel-container {
    border-radius: 14px;
    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.2);
  }
  .hotel-date-popup .ant-picker-cell-in-view .ant-picker-cell-inner {
    border-radius: 10px;
  }
  .hotel-date-popup
    .ant-picker-cell-in-view.ant-picker-cell-selected
    .ant-picker-cell-inner,
  .hotel-date-popup
    .ant-picker-cell-in-view.ant-picker-cell-range-start
    .ant-picker-cell-inner,
  .hotel-date-popup
    .ant-picker-cell-in-view.ant-picker-cell-range-end
    .ant-picker-cell-inner {
    background: #0a72d8;
    color: #fff;
  }
  .hotel-date-popup
    .ant-picker-cell-in-view.ant-picker-cell-in-range
    .ant-picker-cell-inner {
    background: rgba(10, 114, 216, 0.15);
    color: #111827;
  }

  .field-icon-lg {
    font-size: 22px;
    color: #0b0b0b;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .occupancy-shell {
    cursor: pointer;
    user-select: none;
    gap: 10px;
  }

  .occupancy-label {
    flex: 1;
    font-size: 13px;
    font-weight: 500;
    color: #111827;
  }

  .dropdown-icon {
    color: #111827;
    font-size: 14px;
  }

  .search-button {
    height: 44px;
    min-width: 160px;
    padding: 0 28px;
    border-radius: 8px;
    background: var(--pou-search-btn, #8db906);
    border: 1px solid var(--pou-search-btn, #8db906);
    color: #fff !important;
    font-size: 16px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 12px 28px rgba(0, 103, 207, 0.25);
    transition:
      background 0.2s ease,
      transform 0.2s ease;
    &:hover {
      background: #0f6bc5;
      transform: translateY(-1px);
    }
  }

  .occupancy-panel {
    width: 320px;
    padding: 14px;
    background: #fff;
    border: 1px solid #d7d8dd;
    border-radius: 10px;
    box-shadow: 0 18px 38px rgba(0, 0, 0, 0.18);
    position: relative;
    z-index: 120;
  }

  .hotel-search-form .ant-dropdown {
    z-index: 110;
  }

  .occ-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .occ-label {
    font-weight: 700;
    color: #0f172a;
  }

  .counter {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .counter-btn {
    width: 32px;
    height: 32px;
    border: 1px solid #cdd3dd;
    background: #f7f9fc;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1;
    cursor: pointer;
  }

  .counter-value {
    min-width: 22px;
    text-align: center;
    font-weight: 700;
    color: #0f172a;
  }

  .age-selects {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 10px;
  }
  .age-hint {
    font-size: 12px;
    color: #4b5563;
    margin: 4px 0 12px;
    line-height: 1.4;
  }

  .age-selects .ant-select-selector {
    min-height: 38px !important;
    padding: 6px 8px !important;
  }

  .occupancy-info {
    font-size: 12px;
    line-height: 1.5;
    color: #4b5563;
    margin: 6px 0 14px;
  }

  .done-btn {
    height: 40px;
    border-radius: 8px;
    font-weight: 700;
    color: #0a72d8;
    border: 1px solid #0a72d8;
    background: #ffffff;
  }

  @media (max-width: 900px) {
    .search-row {
      flex-direction: column;
    }
    .input-shell,
    .search-button {
      width: 100%;
      min-width: 100%;
    }
    .search-button {
      font-size: 20px;
    }
  }

  @media (max-width: 600px) {
    padding: 12px;
    .input-shell {
      height: 72px;
      padding: 0 18px;
      border-radius: 12px;
    }
    .input-shell .ant-select-selection-item,
    .input-shell .ant-select-selection-placeholder,
    .input-shell .ant-picker-input > input {
      font-size: 13px;
    }
    .field-icon-lg {
      font-size: 22px;
      padding: 8px 0;
    }
    .date-shell {
      height: auto;
      padding: 12px 16px;
      align-items: flex-start;
    }
    .date-grid {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }
    .date-divider {
      width: 100%;
      height: 1px;
    }
    .date-field .ant-picker {
      width: 100%;
    }
    .date-label {
      font-size: 10px;
      letter-spacing: 0.08em;
    }
    .date-shell .ant-picker-input > input {
      font-size: 15px;
    }
    .search-button {
      height: 50px;
      font-size: 18px;
      width: 200px;
    }
    .hotel-date-popup .ant-picker-panel-container {
      left: 45px !important;
      /* border-radius: 0 0 14px 14px; */
    }
  }
`;
